export function formatVideoLength(length, writeHours) {
    let minutes = Math.floor(length / 60);
    let seconds = length % 60;

    let hours = Math.floor(length / 3600);

    if (hours > 0) {
        return [hours, minutes < 10 ? '0'+minutes : minutes, seconds < 10 ? '0'+seconds : seconds].join(':');
    } else return [minutes, seconds < 10 ? "0"+seconds : seconds].join(':');
}

export function formatCount(count) {
    if (count > 0) {
        let numberFormatJs = require('number-format.js');
        return numberFormatJs('# ###.', count);
    }

    return count;
}


// WEBPACK FOOTER //
// ./src/utils/media.js